<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-pre-study`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 28.5c4.307 0 8.232 2.627 11.776 7.882a2 2 0 010 2.236C41.232 43.873 37.307 46.5 33 46.5c-4.307 0-8.232-2.627-11.776-7.882a2 2 0 010-2.236C24.768 31.127 28.693 28.5 33 28.5zM39 4a2 2 0 011.995 1.85L41 6v18.999h-4V8H26v9.997a2 2 0 01-2.77 1.846L19 18.077l-4.23 1.766A2 2 0 0112 17.997V8H9v33h10v4H7a2 2 0 01-1.995-1.85L5 43V6a2 2 0 011.85-1.995L7 4h32zm-6 28c-2.79 0-5.535 1.713-8.288 5.5C27.465 41.287 30.21 43 33 43c2.79 0 5.535-1.713 8.288-5.5C38.535 33.713 35.79 32 33 32zm0 2.5a3 3 0 110 6 3 3 0 010-6zM22 8h-6v6.995l3-1.253 3 1.253V8z"/></svg>
</template>
<script>

export default {
  name: 'IconPreStudy',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
